import { useEffect, useState } from 'react';
import { getDataConnector, getDataConnectorGlobal } from '../../requests/request';
import { useAppSelector } from "../../../../../../redux/hooks";
import Pruebachart from './widgetconnectores';
import { useAuth } from '../../../../auth';

export default function Cloudconnectoredge(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id);
  const tenant = useAppSelector(state => state.TenantSlice.id);
  const Cloud = useAppSelector(state => state.CloudSlice.Type);
  const nameregion = useAppSelector(state => state.RegionSlice.name);
  const FlagReg = useAppSelector(state => state.FlagSlice.value);

  const { currentUser } = useAuth();

  const [DataAvailable, setDataAvailable] = useState({
    Available_DTR_EDG: 0,
    DateUpdate_DTR_EDG: '',
    exceeded_DTR_EDG: 0,
    Total_DTR_EDG: 1,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Cloud !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          const available = tenant === 0
            ? await getDataConnector(Id, props.source, Cloud, nameregion)
            : await getDataConnectorGlobal(Id, tenant, props.source, Cloud, nameregion);

          setDataAvailable(available.data);
        } else if (Id !== 0 && Id !== -1 && Cloud === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
          const available = tenant === 0
            ? await getDataConnector(Id, props.source)
            : await getDataConnectorGlobal(Id, tenant, props.source);

          setDataAvailable(available.data);
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id, nameregion, props.id, FlagReg, currentUser]);

  if (DataAvailable.Available_DTR_EDG === 0) {
    return null;
  }

  const chartColor = DataAvailable.exceeded_DTR_EDG !== 0 ? 'danger' : 'marino';

  return (
    <Pruebachart
      exedido={DataAvailable.exceeded_DTR_EDG}
      name='Edge Connector'
      total={DataAvailable.Total_DTR_EDG}
      disponible={DataAvailable.Available_DTR_EDG}
      className='card-xl-stretch mb-xl-8'
      chartColor={chartColor}
      chartHeight={300}
    />
  );
}
